export abstract class SocketService {
    options: any;
    reconnect: () => void;
}

export function SocketServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Socket');
}

export const SocketServiceProvider = {
    provide: SocketService,
    useFactory: SocketServiceFactory,
    deps: ['$injector']
};
